import { CommonModule, DatePipe, NgForOf, NgIf } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import printJS from 'print-js';
import {
  TuiAppearance,
  TuiButton,
  TuiDataList,
  TuiDropdown,
  TuiLink,
  TuiTextfield,
  TuiLoader,
} from "@taiga-ui/core";
import {
  TuiDataListWrapper,
  TuiItemsWithMore,
  TuiTabs,
} from "@taiga-ui/kit";
import { TuiCell, TuiNavigation, TuiSearch } from "@taiga-ui/layout";
import { TuiTable } from "@taiga-ui/addon-table";
import {
  TuiComboBoxModule,
  TuiInputSliderModule,
  TuiTextfieldControllerModule,
} from "@taiga-ui/legacy";
import { ManualRecordService } from "../../../core/services/manualRecords.service";

@Component({
  selector: "app-single-manual-record",
  standalone: true,
  imports: [
    FormsModule,
    NgForOf,
    NgIf,
    TuiAppearance,
    TuiDataListWrapper,
    TuiDataList,
    TuiDropdown,
    TuiTable,
    TuiNavigation,
    TuiTabs,
    TuiTextfield,
    TuiCell,
    TuiItemsWithMore,
    TuiSearch,
    ReactiveFormsModule,
    CommonModule,
    TuiInputSliderModule,
    TuiTextfieldControllerModule,
    TuiComboBoxModule,
    TuiButton,
    TuiLoader,
  ],
  templateUrl: "./single-manual-record.component.html",
  styleUrl: "./single-manual-record.component.scss",
  providers: [DatePipe],
})
export class SingleManualRecordComponent implements OnInit {
  protected breadcrumbs: string[] = [
    "Royal Hospital",
    "Manual Records",
    "NONREG00001",
  ];
  isLoading = false;
  recordId: string = "";
  record: any | null = null;
  invoiceNumber: string = "";

  constructor(
    private router: Router,
    private manualRecordService: ManualRecordService,
    private route: ActivatedRoute,
    private datePipe: DatePipe
  ) {}

  navigateTo(index: number): void {
    switch (index) {
      case 0:
        this.router.navigate(["admin/manual-records"]);
        break;
      case 1:
        this.router.navigate(["admin/manual-records"]);
        break;
    }
  }

  ngOnInit(): void {
    this.recordId = this.route.snapshot.paramMap.get("id")!;

    if (this.recordId) {
      this.loadRecordData();
    }
  }

  loadRecordData(): void {
    this.isLoading = true;
    this.manualRecordService.getManualRecordById(this.recordId).subscribe({
      next: (res: any) => {
        this.record = res;
        this.breadcrumbs[2] = this.record.chargeRefNo || "Manual Record";
        this.generateInvoiceNumber();
        console.log("Manual record loaded:", this.record);
      },
      error: (err) => {
        console.error("Error loading manual record:", err);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  generateInvoiceNumber(): void {
    if (!this.record || !this.record.date) {
      this.invoiceNumber = "N/A";
      return;
    }

    const date = new Date(this.record.date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const clientRef = this.record.chargeRefNo || "00000";

    this.invoiceNumber = `NONREG${clientRef}${year}${month}`;
  }

  printInvoice(): void {
    setTimeout(() => {
      printJS({
        printable: 'printJS-form',
        type: 'html',
        css: ['styles.css'], 
        targetStyles: ['*'], 
      });
    }, 300);
  }

  getPaymentItems(): any[] {
    if (!this.record) return [];

    const items: any[] = [];

    // Add standard payments
    if (this.record.payments) {
      const standardPayments = [
        { name: "Doctor Charges", value: this.record.payments.doctorPayment },
        { name: "Nursing Charges", value: this.record.payments.nursingPayment },
        {
          name: "Pharmacy Charges",
          value: this.record.payments.pharmacyPayment,
        },
        {
          name: "Laboratory Charges",
          value: this.record.payments.laboratoryPayment,
        },
        {
          name: "Ambulance Charges",
          value: this.record.payments.ambulancePayment,
        },
        {
          name: "Physiotherapy Charges",
          value: this.record.payments.physiotherapyPayment,
        },
        { name: "Other Charges", value: this.record.payments.otherPayment },
      ];

      standardPayments.forEach((payment) => {
        if (payment.value && payment.value > 0) {
          items.push({
            description: payment.name,
            quantity: 1,
            unitPrice: payment.value,
          });
        }
      });
    }

    // Add custom payments
    if (this.record.customPayments && this.record.customPayments.length > 0) {
      this.record.customPayments.forEach((customPayment: any) => {
        if (customPayment.value && customPayment.value > 0) {
          items.push({
            description: customPayment.name,
            quantity: 1,
            unitPrice: customPayment.value,
          });
        }
      });
    }

    return items;
  }
}
